<template>
    <div id="coze-chat-container"></div>
</template>

<script>
export default {
    name: 'CozeChat',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        customer_name: {
            type: String,
            default: 'adil22'
        },
        customer_id: {
            type: String,
            default: '10082'
        }
    },
    data() {
        return {
            dialogVisible: false
        }
    },
    watch: {
        visible: function(newVal) {
            this.dialogVisible = newVal;
            if (newVal) {
                // 弹窗打开后初始化扣子SDK
                setTimeout(() => {
                    this.initCozeChat();
                }, 0);
            }
        }
    },
    methods: {
        closeDialog() {
            this.dialogVisible = false;
            this.$emit('close');
        },
        showChat() {
            console.log('showChat');
            if (window.cozeWebSDK && typeof window.cozeWebSDK.showChatBot === 'function') {
                window.cozeWebSDK.showChatBot();
            } else {
                console.warn('Coze SDK 尚未完全初始化，请稍后再试');
                // 如果SDK未初始化，可以尝试重新初始化
                this.initCozeChat();
            }
        },
        // 创建新对话框，允许传入不同的customer_id和customer_name，确保每次都是全新会话
        createNewChat(customerId, customerName) {
            console.log('创建新对话框(全新会话)', {customerId, customerName});
            
            // 如果SDK已存在，先彻底清理旧实例
            if (window.cozeWebSDK) {
                try {
                    // 隐藏聊天窗口
                    if (typeof window.cozeWebSDK.hideChatBot === 'function') {
                        window.cozeWebSDK.hideChatBot();
                    }
                    // 如果有destroy方法，调用它
                    if (typeof window.cozeWebSDK.destroy === 'function') {
                        window.cozeWebSDK.destroy();
                    }
                } catch (error) {
                    console.warn('清理Coze SDK实例时出错:', error);
                }
                
                // 删除SDK引用
                delete window.cozeWebSDK;
                
                // 清空容器内容
                const container = document.getElementById('coze-chat-container');
                if (container) {
                    container.innerHTML = '';
                }
                
                // 移除可能存在的SDK相关localStorage，防止会话信息残留
                try {
                    Object.keys(localStorage).forEach(key => {
                        if (key.includes('coze') || key.includes('conversation')) {
                            localStorage.removeItem(key);
                        }
                    });
                } catch (e) {
                    console.warn('清理localStorage时出错:', e);
                }
            }
            
            // 动态设置临时的customer_id和customer_name
            const tempCustomerId = customerId || this.customer_id || '10082';
            const tempCustomerName = customerName || this.customer_name || '客户';
            
            // 生成唯一会话标识，确保每次都是全新会话
            const uniqueSessionId = `${tempCustomerId}_${Date.now()}`;
            console.log('唯一会话ID:', uniqueSessionId);
            // 动态加载扣子SDK
            const script = document.createElement('script');
            script.src = 'https://lf-cdn.coze.cn/obj/unpkg/flow-platform/chat-app-sdk/1.2.0-beta.19/libs/cn/index.js';
            script.onload = () => {
                window.cozeWebSDK = new window.CozeWebSDK.WebChatClient({
                    config: {
                        bot_id: '7570730922740514858',
                        isIframe: false,
                        autoCreateNewConversation: true,
                        botInfo: {
                            parameters: {
                                customer_name: tempCustomerName,
                                customer_id: tempCustomerId,
                                session_id: uniqueSessionId 
                            }
                        },
                    },
                    chatBot: {
                        el: '#coze-chat-container',
                        title: 'AI 助手',
                    },
                    ui: {
                        // 禁用会话列表，防止加载历史记录
                        conversations: {
                            isNeed: false
                        },
                        // 禁用历史会话选择
                        header: false,
                        asstBtn: {
                            isNeed: true
                        },
                        footer: {
                            isShow: true,
                            expressionText: 'Powered by 品荟网络科技',
                        },
                        chatBot: {
                            title: "康养膳食大模型",
                            uploadable: true,
                            width: '20%',
                            el: undefined,
                            // 允许添加新会话
                            isNeedAddNewConversation: false,
                            isNeedQuote: true,
                            onHide: () => {
                                console.log('聊天窗口已隐藏');
                            },
                            onShow: () => {
                                console.log('聊天窗口已显示，开始新会话');
                                // 确保创建新会话
                                if (window.cozeWebSDK && typeof window.cozeWebSDK.startChat === 'function') {
                                    window.cozeWebSDK.startChat();
                                }
                            },
                        },
                    },
                    // 使用唯一ID确保新会话
                    userInfo: {
                        id: uniqueSessionId, // 使用唯一会话ID作为用户ID
                        url: 'https://lf-coze-web-cdn.coze.cn/obj/coze-web-cn/obric/coze/favicon.1970.png',
                        nickname: tempCustomerName,
                    },
                    // 配置会话参数，强制创建新会话
                    conversation: {
                        id: uniqueSessionId, // 使用唯一会话ID
                        title: `新会话 - ${new Date().toLocaleString()}`,
                        createTime: Date.now()
                    },
                    auth: {
                        type: 'token',
                        token: 'pat_JzpuP3BLUDmGceOqPYGOMeX2l8WiSm0fxYvFUSYaFsevfP48D0E4OEGs338mxwSv',
                        onRefreshToken: async function () {
                            return 'pat_JzpuP3BLUDmGceOqPYGOMeX2l8WiSm0fxYvFUSYaFsevfP48D0E4OEGs338mxwSv';
                        }
                    }
                });
                
                // 确保SDK初始化完成后显示聊天窗口
                setTimeout(() => {
                    if (window.cozeWebSDK && typeof window.cozeWebSDK.showChatBot === 'function') {
                        window.cozeWebSDK.showChatBot();
                    }
                }, 100);
            };
            script.onerror = (error) => {
                console.error('加载Coze SDK失败:', error);
            };
            document.body.appendChild(script);
        },
        initCozeChat() {
            // 确保SDK只加载一次
            if (window.cozeWebSDK) {
                return;
            }
            console.log('initCozeChat');

            // 动态加载扣子SDK
            const script = document.createElement('script');
            // script.src = 'https://lf-cdn.coze.cn/obj/unpkg/flow-platform/chat-app-sdk/1.1.0-beta.0/libs/cn/index.js'
            script.src = 'https://lf-cdn.coze.cn/obj/unpkg/flow-platform/chat-app-sdk/1.2.0-beta.19/libs/cn/index.js';
            script.onload = () => {
                window.cozeWebSDK = new window.CozeWebSDK.WebChatClient({
                    config: {
                        // type: "bot",
                        bot_id: '7570730922740514858',
                        isIframe: false,
                        autoCreateNewConversation: true,
                        botInfo: {
                            parameters: {
                                customer_name: this.customer_name || '客户',
                                customer_id: this.customer_id || '10082'
                            }
                        },
                    },
                    chatBot: {
                        el: '#coze-chat-container',
                        title: 'AI 助手',
                    },
                    ui: {
                        conversations: {
                            isNeed: false 
                        },
                        header: false,
                        // 悬浮球配置
                        asstBtn: {
                            isNeed: false
                        },
                        // 配置底部文案
                        footer: {
                            isShow: true,
                            expressionText: 'Powered by 品荟网络科技',
                        },
                        //配置聊天框
                        chatBot: {
                            title: "康养膳食大模型",
                            uploadable: true,
                            width: '20%',
                            el: undefined,
                            isNeedAddNewConversation: false,
                            isNeedQuote: true,
                            onHide: () => {
                                // todo...
                            },
                            onShow: () => {
                                
                                // window.cozeWebSDK.startChat();
                            },
                        },
                    },
                    // 配置用户信息
                    userInfo: {
                        id: '12345',
                        url: 'https://lf-coze-web-cdn.coze.cn/obj/coze-web-cn/obric/coze/favicon.1970.png',
                        nickname: this.customer_name || '客户',
                    },
                    auth: {
                        type: 'token',
                        token: 'pat_JzpuP3BLUDmGceOqPYGOMeX2l8WiSm0fxYvFUSYaFsevfP48D0E4OEGs338mxwSv',
                        onRefreshToken: async function () {
                            return 'pat_JzpuP3BLUDmGceOqPYGOMeX2l8WiSm0fxYvFUSYaFsevfP48D0E4OEGs338mxwSv';
                        }
                    }
                });
            };
            document.body.appendChild(script);
        }
    },
    // 暴露方法给父组件
    expose: ['showChat', 'createNewChat']
};
</script>

<style scoped>
    .dialog-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }
</style>

<style>
    /* 将对话框定位到右侧 */
    .right-side-dialog {
        position: fixed;
        right: 0;
        top: 0;
        margin: 0 !important;
        height: 100vh;
        display: flex;
        flex-direction: column;
    }

    /* 调整对话框内容区域高度 */
    .right-side-dialog .el-dialog__body {
        flex: 1;
        padding: 0;
        overflow: hidden;
    }

    /* 确保扣子聊天容器占满整个空间 */
    #coze-chat-container {
        height: 100%;
        min-height: 500px;
    }
</style>